interface SummaryCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  icon?: string;
}

export function SummaryCard({ label, value, subtitle, icon }: SummaryCardProps) {
  return (
    <div className="surface" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
        {icon && (
          <div
            style={{
              width: '38px',
              height: '38px',
              borderRadius: '12px',
              display: 'grid',
              placeItems: 'center',
              background: 'rgba(14, 165, 233, 0.14)',
              fontSize: '1.1rem'
            }}
          >
            {icon}
          </div>
        )}
        <span className="text-muted" style={{ fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          {label}
        </span>
      </div>
      <div style={{ fontSize: '1.6rem', fontWeight: 600 }}>{value}</div>
      {subtitle && <div className="text-muted" style={{ fontSize: '0.85rem' }}>{subtitle}</div>}
    </div>
  );
}

